<template>
    <div class="search-module">
        <div class="wd-ht-px-40 mg-l-10 br-rd-pr-50 solid-tint-black-black50 dp-fx fx-al-ct fx-js-ct cs-ptr" v-on:click="enableSearch">
            <img src="@/assets/search.png" width=16 alt="Search Icon">
        </div>
        <TintFullScreen v-bind:active="tintActive" @click.native="tintClicked"/>
        <SearchBox v-bind:active="searchBoxActive" v-on:cancel-search-clicked="disableSearch"/>
    </div>
</template>

<script>
    import TintFullScreen from "@/components/TintFullScreen.vue";
    import SearchBox from "@/components/SearchBox.vue";
    export default {
        name : 'SearchModule',
        components : {
            TintFullScreen : TintFullScreen,
            SearchBox : SearchBox,
        },
        data : function () {
            return {
                tintActive : false,
                searchBoxActive : false,
            }
        },
        methods : {
            enableSearch() {
                this.tintActive = true;
                this.searchBoxActive = true;
            },
            tintClicked() {
                this.tintActive = false;
                this.searchBoxActive = false;
            },
            disableSearch() {
                this.tintActive = false;
                this.searchBoxActive = false;
            }
        }
    }
</script>

<style>
    .wd-ht-px-40{
        width: 40px;
        height: 40px;
    }
    .search-module .tint-full-screen{
        z-index: 11;
    }
    .search-module .search-box{
        z-index: 12;
    }
</style>